import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import { useSetErrorMutation } from '../../app/services/auth-rtk.service';
import { WrappedErrorBoundary } from '../WrappedErrorBoundary';

function Custom500() {
  const { t } = useTranslation();
  const error = useRouteError();

  const [setError] = useSetErrorMutation();

  useEffect(() => {
    const str: string = (error as any)?.stack?.toString();

    if (str?.includes('dynamically imported')) {
      window?.location?.reload();
    }

    if (!window.location.hostname.includes('localhost')) {
      setError({
        error: String(str),
        message: String(error) as string,
      }).unwrap();
    }
  }, [error]);

  return (
    <div className="tw-w-full tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-py-16 tw-bg-gray-50">
      <div className="tw-max-w-3xl tw-w-full tw-text-center tw-space-y-8">
        {/* Error code - large background number */}
        <div className="tw-relative">
          <div className="tw-text-[150px] lg:tw-text-[200px] tw-font-bold tw-text-gray-200 tw-select-none tw-leading-none">500</div>
        </div>

        {/* Error message */}
        <div className="tw-space-y-4 tw--mt-20 lg:tw--mt-28">
          {/* Title */}
          <h1 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-gray-800 tw-font-['Lexend']">{t('site/500/desktopTitle')}</h1>

          {/* Description */}
          <div className="tw-space-y-2">
            <p className="tw-text-base lg:tw-text-xl tw-text-gray-700 tw-font-['Lexend']">{t('site/500/desktopDescription1')}</p>
            <p className="tw-text-base lg:tw-text-lg tw-text-gray-600 tw-font-['Lexend']">{t('site/500/desktopDescription2')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WrappedErrorBoundary(Custom500);
